module.exports = __webpack_public_path__ + "static/media/CONSTITUTION_OF_SALEM_MANOR_SUBDIVISION.212f2ece.pdf";